var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var AttachmentIcon = function (props) {
    var _a = props.width, w = _a === void 0 ? '1em' : _a, _b = props.height, h = _b === void 0 ? '1em' : _b, rest = __rest(props, ["width", "height"]);
    return (_jsx("svg", __assign({ width: w, height: h, viewBox: '0 0 16 18', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, rest, { children: _jsx("path", { d: 'M11.7502 0C10.7073 0 9.68188 0.404297 8.89087 1.19531L1.85962 8.22656C-0.369873 10.4561 -0.369873 14.083 1.85962 16.3125C4.08911 18.542 7.71606 18.542 9.94556 16.3125L14.6331 11.625L13.5784 10.5703L8.89087 15.2578C7.2356 16.9131 4.56958 16.9131 2.91431 15.2578C1.25903 13.6025 1.25903 10.9365 2.91431 9.28125L9.94556 2.25C10.9534 1.24219 12.5706 1.24219 13.5784 2.25C14.5862 3.25781 14.5862 4.875 13.5784 5.88281L6.54712 12.9141C6.18677 13.2744 5.61841 13.2744 5.25806 12.9141C4.89771 12.5537 4.89771 11.9854 5.25806 11.625L11.7034 5.17969L10.6487 4.125L4.20337 10.5703C3.2688 11.5049 3.2688 13.0342 4.20337 13.9688C5.13794 14.9033 6.66724 14.9033 7.60181 13.9688L14.6331 6.9375C16.2151 5.35547 16.2151 2.77734 14.6331 1.19531C13.842 0.404297 12.7932 0 11.7502 0Z', fill: 'currentColor' }) })));
};
